import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SessionService} from "../service/session.service";
import {environment} from "../../../environments/environment";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MessageService} from "../service/message.service";
import firebase from "firebase/compat/app";
import {COLLECTION_NAME, logError, USABLE_STRING_FOR_PASSWORD} from "../../shared/constants";
import {CommonService} from "../service/common.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['../../shared/layout/layout.component.scss', './header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() disabledMenu = false;
  @Output() hamburgerClick: EventEmitter<any> = new EventEmitter<any>();
  public login = false;
  public user = {displayName: '', email: ''};
  color = environment.color;
  title = environment.title;
  shortenTitle = environment.title_xs;
  isSmallWindow = (window.innerWidth <= 414);

  showPassword = false;
  passwordInputShown = false;
  pass = {password: '', confirmpassword: ''}

  name: string;
  mail: string;
  isNabelAdmin: boolean;

  usableStringForPassword = USABLE_STRING_FOR_PASSWORD;

  constructor(public sessionService: SessionService,
              public messageService: MessageService,
              private db: AngularFirestore,
              public commonService: CommonService) {
    this.name = this.sessionService.session.personalSetting?.name ?? "";
    this.mail = this.sessionService.session.personalSetting?.mail ?? "";
    this.isNabelAdmin = this.sessionService.session.personalSetting?.nabelAdmin ?? false;
  }

  ngOnInit(): void {
  }

  resetPasswordModal() {
    this.passwordInputShown = false;
    this.pass.password = this.pass.confirmpassword = '';
  }

  switchPasswordModalShown() {
    this.passwordInputShown = !this.passwordInputShown;
    this.pass.password = this.pass.confirmpassword = '';
  }

  passwordConfirmed(): boolean {
    const enoughLength = this.pass.password.length >= 6;
    const agrees = this.pass.password === this.pass.confirmpassword;
    return enoughLength && agrees;
  }

  updatePassword() {
    const user = firebase.auth().currentUser;
    user?.updatePassword(this.pass.password).then(() => {
      this.messageService.pushInfo('パスワードを更新しました！')
    }).catch(e => {
      this.messageService.pushError('更新に失敗しました')
      console.error(e);
    })
  }

  async alterNabelAdmin(): Promise<void> {
    const mail = this.sessionService.session.personalSetting.mail;
    const account = Object.assign({}, this.sessionService.session.personalSetting);
    account.nabelAdmin = !(account.nabelAdmin ?? false);
    return this.db.collection(COLLECTION_NAME.USERS).doc(mail)
      .set(account, {merge: true})
      .then(() => {
        this.sessionService.logout();
        location.reload();
      })
      .catch(logError);
  }

}
